export default __webpack_public_path__ + "static/media/dune_pilat_landscape.571cd847.jpeg";